module.exports = __webpack_public_path__ + "img/icon-facebook.1a81861b.svg";